export default __webpack_public_path__ + "static/media/redis.756a0f80.svg";